var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentPaytrail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_46127)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "#E31A94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5769 5.31663C14.8972 5.31663 15.1592 5.06292 15.1592 4.74682C15.1592 4.43072 14.8972 4.177 14.5769 4.177C14.2567 4.177 13.9946 4.43072 13.9946 4.74682C13.9946 5.06292 14.2525 5.31663 14.5769 5.31663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4605 5.33329C21.7807 5.33329 22.0428 5.07126 22.0428 4.75099C22.0428 4.43073 21.7807 4.1687 21.4605 4.1687C21.1402 4.1687 20.8782 4.43073 20.8782 4.75099C20.8782 5.07126 21.1402 5.33329 21.4605 5.33329Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5645 4.78857C14.5645 6.68935 16.1034 8.22827 18.0041 8.22827C19.9049 8.22827 21.4438 6.68935 21.4438 4.78857",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8455 13.8307V13.5894V11.8592H22.5793V11.5181H23.2074V13.4896H23.4736V13.8307H22.8455ZM22.0594 13.8307L22.0553 13.6893V12.4956H21.7932V12.1545H22.4129V13.4855H22.6667V13.8265H22.0594V13.8307ZM22.3464 11.8717C22.3006 11.9133 22.2466 11.9382 22.1883 11.9382C22.1301 11.9382 22.076 11.9174 22.0303 11.8717C21.9887 11.8259 21.9638 11.7719 21.9638 11.7136C21.9638 11.6512 21.9845 11.5972 22.0303 11.5514C22.076 11.5098 22.1301 11.4849 22.1883 11.4849C22.2466 11.4849 22.3006 11.5057 22.3464 11.5514C22.388 11.5972 22.4129 11.6512 22.4129 11.7095C22.4129 11.7719 22.3922 11.8259 22.3464 11.8717ZM21.2608 13.1694C21.2192 13.1486 21.1735 13.1278 21.1319 13.1153C21.0778 13.0945 21.0154 13.0862 20.9489 13.0862C20.8907 13.0862 20.8408 13.0945 20.8033 13.107C20.7659 13.1194 20.7326 13.1402 20.7118 13.161C20.6619 13.2068 20.6328 13.265 20.6328 13.3316C20.6328 13.3815 20.6536 13.4314 20.691 13.473C20.7077 13.4896 20.7326 13.5063 20.7576 13.5146C20.7825 13.5229 20.82 13.5312 20.8616 13.5312C20.9281 13.5312 21.003 13.5104 21.082 13.473C21.1485 13.4397 21.2068 13.3981 21.2567 13.3482V13.1694H21.2608ZM21.2608 13.8307V13.7184C21.1984 13.7558 21.1277 13.7891 21.0529 13.814C20.978 13.839 20.9031 13.8515 20.8283 13.8515C20.6702 13.8515 20.5371 13.7974 20.429 13.6934C20.325 13.5936 20.2709 13.4647 20.2709 13.3149C20.2709 13.1527 20.3333 13.0196 20.4581 12.9156C20.5163 12.8616 20.587 12.8241 20.6661 12.7992C20.7451 12.7742 20.8283 12.7618 20.9239 12.7618C20.9946 12.7618 21.0737 12.7742 21.1527 12.7909C21.1693 12.795 21.186 12.7992 21.2068 12.8033C21.2234 12.8075 21.2442 12.8158 21.2608 12.8241V12.6328C21.2608 12.5912 21.2567 12.5579 21.2442 12.5372C21.2317 12.5164 21.2192 12.4956 21.1985 12.4831C21.1735 12.4664 21.1444 12.454 21.1069 12.4456C21.0695 12.4373 21.0238 12.4332 20.9697 12.4332C20.9447 12.4332 20.9115 12.4373 20.8782 12.4456C20.8449 12.454 20.8075 12.4623 20.77 12.4748C20.7326 12.4872 20.6993 12.4956 20.6661 12.508C20.6328 12.5205 20.6078 12.5288 20.5829 12.5372L20.4706 12.2585C20.5413 12.2294 20.6037 12.2044 20.6577 12.1878C20.7077 12.1711 20.7659 12.1545 20.8241 12.1379C20.8823 12.1254 20.9323 12.1171 20.978 12.1171C21.0737 12.1171 21.161 12.1254 21.2359 12.1462C21.3149 12.167 21.3815 12.1961 21.4438 12.2377C21.5062 12.2834 21.552 12.3417 21.5811 12.4082C21.6102 12.4748 21.6227 12.5496 21.6227 12.6328V13.4896H21.8681V13.8307H21.2608ZM20.1462 12.4914C20.0463 12.4914 19.9632 12.5039 19.9008 12.5247C19.8342 12.5455 19.7843 12.5746 19.7427 12.612C19.7053 12.6453 19.6762 12.6827 19.6554 12.7285C19.6346 12.7742 19.6263 12.8408 19.6263 12.9281V13.4896H19.9299V13.8307H19.2686V13.5894V12.4956H18.9899V12.1545H19.6304V12.3292C19.6387 12.325 19.6554 12.3126 19.6845 12.2918C19.7136 12.271 19.7427 12.2543 19.7718 12.2418C19.8384 12.2086 19.9049 12.1878 19.959 12.1753C20.0172 12.1628 20.0796 12.1587 20.1545 12.1587L20.3084 12.1628V12.4914H20.1462ZM18.5407 13.8639C18.4825 13.8639 18.4284 13.8556 18.3826 13.839C18.3369 13.8224 18.2953 13.7974 18.2579 13.76C18.2246 13.7267 18.1996 13.6851 18.183 13.6352C18.1705 13.5894 18.1622 13.5395 18.1622 13.4855V12.4956H17.9002V12.1545H18.1622V11.8259L18.5241 11.8176V12.1545H18.8318V12.4956H18.5241V13.4522C18.5241 13.4855 18.5282 13.5063 18.5324 13.5146H18.549L18.8318 13.4688V13.8099L18.5407 13.8639ZM17.4801 12.4997L16.7273 14.492H16.3737L16.6566 13.6934L16.1699 12.4997H15.8913V12.1587H16.407L16.486 12.3625L16.8396 13.2234L17.1141 12.4997H16.9269V12.1587H17.738V12.4997H17.4801ZM15.3381 13.1694C15.2965 13.1486 15.2507 13.1278 15.2091 13.1153C15.1551 13.0945 15.0927 13.0862 15.0261 13.0862C14.9679 13.0862 14.918 13.0945 14.8806 13.107C14.8431 13.1194 14.8099 13.1402 14.7891 13.161C14.7392 13.2068 14.71 13.265 14.71 13.3316C14.71 13.3815 14.7308 13.4314 14.7683 13.473C14.7849 13.4896 14.8099 13.5063 14.8348 13.5146C14.8598 13.5229 14.8972 13.5312 14.9388 13.5312C15.0053 13.5312 15.0802 13.5104 15.1592 13.473C15.2258 13.4397 15.284 13.3981 15.3339 13.3482V13.1694H15.3381ZM15.3381 13.8307V13.7184C15.2757 13.7558 15.205 13.7891 15.1301 13.814C15.0553 13.839 14.9804 13.8515 14.9055 13.8515C14.7475 13.8515 14.6144 13.7974 14.5062 13.6934C14.4023 13.5936 14.3482 13.4647 14.3482 13.3149C14.3482 13.1527 14.4106 13.0196 14.5353 12.9156C14.5936 12.8616 14.6643 12.8241 14.7433 12.7992C14.8223 12.7742 14.9055 12.7618 15.0012 12.7618C15.0719 12.7618 15.1509 12.7742 15.2299 12.7909C15.2466 12.795 15.2632 12.7992 15.284 12.8033C15.3006 12.8075 15.3214 12.8158 15.3381 12.8241V12.6328C15.3381 12.5912 15.3339 12.5579 15.3214 12.5372C15.309 12.5164 15.2965 12.4956 15.2757 12.4831C15.2507 12.4664 15.2216 12.454 15.1842 12.4456C15.1468 12.4373 15.101 12.4332 15.0469 12.4332C15.0178 12.4332 14.9887 12.4373 14.9554 12.4456C14.9222 12.454 14.8847 12.4623 14.8473 12.4748C14.8099 12.4872 14.7766 12.4956 14.7433 12.508C14.71 12.5205 14.6851 12.5288 14.6601 12.5372L14.5478 12.2585C14.6185 12.2294 14.6809 12.2044 14.735 12.1878C14.7849 12.1711 14.8431 12.1545 14.9014 12.1379C14.9596 12.1254 15.0095 12.1171 15.0553 12.1171C15.1509 12.1171 15.2383 12.1254 15.3131 12.1462C15.3922 12.167 15.4587 12.1961 15.5211 12.2377C15.5835 12.2834 15.6292 12.3417 15.6583 12.4082C15.6875 12.4748 15.6999 12.5496 15.6999 12.6328V13.4896H15.9453V13.8307H15.3381ZM13.9572 12.063C13.9406 12.0131 13.9156 11.9757 13.8865 11.9507C13.8574 11.9216 13.8116 11.9008 13.7534 11.8842C13.6952 11.8675 13.6203 11.8592 13.5247 11.8592H13.2044V12.6203H13.5247C13.6078 12.6203 13.6827 12.612 13.7368 12.5954C13.795 12.5787 13.8408 12.5579 13.8782 12.5288C13.9115 12.5039 13.9364 12.4664 13.9572 12.4249C13.9739 12.3833 13.9863 12.3292 13.9863 12.2626C13.9863 12.1795 13.9739 12.1129 13.9572 12.063ZM14.3066 12.533C14.2733 12.6203 14.2192 12.6994 14.1444 12.7659C14.0737 12.8325 13.9905 12.8824 13.8948 12.9115C13.8033 12.9406 13.6993 12.9572 13.587 12.9572H13.2044V13.5894V13.8307H12.5514V13.4896H12.8301V11.8592H12.5514V11.5181H13.5579C13.6744 11.5181 13.7825 11.5348 13.8823 11.5639C13.9822 11.593 14.0695 11.6429 14.1402 11.7095C14.2151 11.776 14.2692 11.855 14.3066 11.9424C14.3399 12.0297 14.3607 12.1295 14.3607 12.2418C14.3565 12.3458 14.3399 12.4415 14.3066 12.533Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5324 14.8205C18.7445 14.8205 18.9026 14.9577 18.9026 15.1782V15.3653C18.9026 15.6232 18.7362 15.7355 18.5158 15.7355C18.4076 15.7355 18.2745 15.7106 18.1789 15.6731C18.1622 15.669 18.1581 15.6607 18.1581 15.644V14.5335C18.1581 14.5169 18.1664 14.5085 18.183 14.5085H18.3286C18.3452 14.5085 18.3536 14.5169 18.3536 14.5335V14.8579C18.3993 14.8371 18.4617 14.8205 18.5324 14.8205ZM18.7029 15.3653V15.1782C18.7029 15.0492 18.6322 14.9952 18.5116 14.9952C18.4492 14.9952 18.391 15.0118 18.3494 15.0409V15.54C18.391 15.5567 18.4492 15.565 18.5075 15.565C18.6281 15.5608 18.7029 15.5109 18.7029 15.3653Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6138 14.8663C19.6138 14.8496 19.6221 14.8413 19.6388 14.8413H19.7843C19.801 14.8413 19.8093 14.8496 19.8093 14.8663V15.6607C19.8093 15.9186 19.6928 16.0517 19.435 16.0517C19.2936 16.0517 19.1937 16.0184 19.1064 15.9435C19.0939 15.9352 19.0939 15.9227 19.1022 15.9102L19.1729 15.8063C19.1813 15.7938 19.1937 15.7896 19.2062 15.7979C19.2686 15.8437 19.3435 15.877 19.435 15.877C19.5514 15.877 19.6263 15.8271 19.618 15.6565C19.5639 15.6732 19.5015 15.6856 19.4391 15.6856C19.2644 15.6856 19.0773 15.5733 19.0773 15.3404V14.8621C19.0773 14.8455 19.0856 14.8372 19.1022 14.8372H19.2478C19.2644 14.8372 19.2728 14.8455 19.2728 14.8621V15.3321C19.2728 15.461 19.3643 15.5068 19.4641 15.5068C19.5223 15.5068 19.5805 15.4943 19.6138 15.4735V14.8663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4083 15.7148C20.3916 15.7148 20.3833 15.7065 20.3833 15.6898V14.9162C20.3833 14.9037 20.3875 14.8913 20.3999 14.8871C20.4998 14.8455 20.6162 14.8206 20.7368 14.8206C20.9698 14.8206 21.1278 14.9287 21.1278 15.199V15.6898C21.1278 15.7065 21.1195 15.7148 21.1028 15.7148H20.9573C20.9406 15.7148 20.9323 15.7065 20.9323 15.6898V15.2032C20.9323 15.0452 20.8616 14.9994 20.7368 14.9994C20.6786 14.9994 20.6162 15.0077 20.5788 15.016V15.6898C20.5788 15.7065 20.5705 15.7148 20.5538 15.7148H20.4083Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0428 15.3363C22.0428 15.3529 22.0345 15.3613 22.0179 15.3613H21.5021V15.407C21.5021 15.511 21.5728 15.5609 21.681 15.5609C21.785 15.5609 21.8557 15.5235 21.918 15.4819C21.9305 15.4736 21.943 15.4736 21.9513 15.486L22.022 15.5775C22.0303 15.59 22.0303 15.6025 22.0179 15.615C21.9305 15.6857 21.8182 15.7314 21.6768 15.7314C21.4855 15.7314 21.3066 15.6275 21.3066 15.4029V15.1616C21.3066 14.9121 21.4938 14.8164 21.6768 14.8164C21.8598 14.8164 22.0428 14.9162 22.0428 15.1616V15.3363ZM21.6768 14.9953C21.577 14.9953 21.5021 15.041 21.5021 15.1658V15.2115H21.8473V15.1658C21.8515 15.041 21.7725 14.9953 21.6768 14.9953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5377 15.5567C22.5543 15.5567 22.5793 15.5567 22.6084 15.5525C22.625 15.5525 22.6333 15.5608 22.6333 15.5775V15.7064C22.6333 15.7189 22.625 15.7313 22.6084 15.7313C22.5793 15.7313 22.546 15.7355 22.521 15.7355C22.3464 15.7355 22.2091 15.6482 22.2091 15.4236V14.6541C22.2091 14.6375 22.2174 14.6292 22.2341 14.6292H22.363C22.3755 14.6292 22.388 14.6375 22.388 14.6499L22.4046 14.8537H22.5834C22.6001 14.8537 22.6084 14.8621 22.6084 14.8787V15.0035C22.6084 15.0201 22.6001 15.0284 22.5834 15.0284H22.4046V15.4152C22.4046 15.5026 22.4545 15.5567 22.5377 15.5567Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1877_46127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 14,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3H11V17H25V3Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1877_46127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0785 15.7356C22.962 15.7356 22.8414 15.7023 22.7374 15.6274C22.7208 15.6191 22.7208 15.6067 22.7291 15.5942L22.7915 15.486C22.7998 15.4694 22.8081 15.4694 22.8248 15.4777C22.8996 15.5318 22.9911 15.5651 23.0785 15.5651C23.1658 15.5651 23.2365 15.5318 23.2365 15.4652C23.2365 15.3987 23.1575 15.3779 23.0785 15.3654C22.9537 15.3405 22.7374 15.2906 22.7374 15.0867C22.7374 14.8996 22.9163 14.8206 23.0951 14.8206C23.1908 14.8206 23.2906 14.8455 23.3904 14.8996C23.4029 14.9079 23.4071 14.9204 23.3987 14.9329L23.3363 15.041C23.328 15.0535 23.3155 15.0576 23.3031 15.0493C23.2407 15.016 23.1658 14.9952 23.091 14.9952C22.9911 14.9952 22.9371 15.0327 22.9371 15.0867C22.9371 15.1575 23.0119 15.1741 23.1242 15.1949C23.2615 15.2198 23.4362 15.2656 23.4362 15.4569C23.4362 15.6441 23.2781 15.7356 23.0785 15.7356Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 19,
    rx: 1.5,
    stroke: "#DADADA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_46127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(11 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPaytrail);
export default __webpack_public_path__ + "static/media/payment-paytrail.353e812153aa757c867b32b5e3d4268e.svg";
export { ForwardRef as ReactComponent };